import { useVisitTracker } from '@/hooks/useVisitTracker';

/**
 * Component that tracks page visits
 * Must be used inside BrowserRouter to access location
 */
export const VisitTracker = () => {
  useVisitTracker();
  return null;
};
